import { mobileOnScroll } from '@/utils/mobileOnScroll'
import { desktopOnScroll } from '@/utils/desktopOnScroll'
import { closeIcon } from '@/utils/closeIcon'

export default async function initializeVimeo(
    container: HTMLElement,
    takeoverVideoId: string,
    isDesktop: boolean,
) {
    const vimeoPlayer = document.createElement('iframe')
    const closeButton = document.createElement('div')

    // close button setup
    closeButton.innerHTML = closeIcon

    // player element setup
    vimeoPlayer.src = `https://player.vimeo.com/video/${takeoverVideoId}?transparent=0&autoplay=1&muted=1`
    vimeoPlayer.allow = 'autoplay'
    vimeoPlayer.id = 'vmPlayer'
    container.appendChild(vimeoPlayer)

    if (!isDesktop) {
        mobileOnScroll(vimeoPlayer, closeButton)
    } else {
        desktopOnScroll(vimeoPlayer, closeButton)
    }
}
